<div class="p-grid">
    <div class="p-col-12 page-header">System Deals</div>
    <div class="p-col-12 divider-header">
        <p-divider></p-divider>
    </div>
    <div class="p-col-12">
        <div class="p-grid">
            <div class="p-col-12 p-lg-2 p-md-2 p-sm-4">
                <button pButton type="button" class="fullwidthbtn" label="New Deal" routerLink="/deal/new"></button>
            </div>
            <div class="p-col-12 p-lg-2 p-md-2 p-sm-2">
                <button pButton type="button" class="fullwidthbtn" label="Search" (click)="showSearchDealsDialog()"></button>
            </div>
            <div class="p-col-12 p-lg-2 p-md-2 p-sm-2">
                <button pButton type="button" class="fullwidthbtn" label="Clear" (click)="dealStatusOnChange()"></button>
            </div>
            <div class="p-col-12 p-lg-2 p-md-2 p-sm-1"></div>
            <div class="p-col-12 p-lg-4 p-md-4 p-sm-4">
                <p-dropdown [options]="dealStatusOptions"
                            [(ngModel)]="selectedDealStatusId"
                            (onChange)="dealStatusOnChange()">
                </p-dropdown>
            </div>
        </div>
    </div>   
    <div class="p-col-12" *ngIf="deals" style="margin-top: -15px;">
        <div class="card">
            <div id="dataListWrapper">
                <p-dataView #dv [value]="dealsFiltered" [paginator]="true" filterBy="Id,PropertyAddress,ClientCoName,ProposingBrokerName,ReceivingBrokerName,ProposingMemberName,ReceivingMemberName"
                            [rows]="10"
                            [showCurrentPageReport]="true"
                            [rowsPerPageOptions]="rowsPerPageOptions"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                    <ng-template pTemplate="header">
                        <div class="p-grid">
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <input type="search" pInputText placeholder="Search Deal" (input)="dv.filter($event.target.value)">
                            </div>
                        </div>
                    </ng-template>
                    <ng-template let-deal pTemplate="listItem">
                        <div class="p-col-12">
                            <div class="object-list-item">
                                <div class="object-list-detail">                                    
                                    <div class="p-grid">
                                        <div class="p-col-12 p-lg-9 p-md-9">
                                            <div *ngIf="deal.PropertyCity" style="font-size: 15px;color: #9B9B9B">{{deal.PropertyCity}}, {{deal.StatesName}}</div>
                                            <div class="object-name">
                                                <span>{{deal.Title}}</span>
                                            </div>
                                        </div>
                                        <div class="p-col-12 p-lg-3 p-md-3">
                                            <div class="deal-id floatRight">Deal #{{deal.Id}}</div>
                                            <div class="deal-accept floatRight">1 of 3 accepted</div>
                                        </div>
                                    </div>
                                    <div class="deal-detail" [ngStyle]="{'color': (deal.DealStatusID == 1) ? '#1d6498' : (deal.DealStatusID == 2) ? '#d48127' : (deal.DealStatusID == 3) ? '#0ca325' : ''}"><strong>Status: </strong>{{dealStatuses[deal.DealStatusID]}}</div>
                                    <div class="deal-detail"><b>Company:</b> {{deal.ClientCoName}}</div>
                                    <div class="deal-detail">
                                        <b>Proposing Broker: </b>
                                        <p-button label=" {{deal.ProposingBrokerName}}" styleClass="p-button-link" routerLink="/user/{{deal.ProposingUserID}}"></p-button>
                                    </div>
                                    <div class="deal-detail">
                                        <b>Receiving Broker: </b>
                                        <p-button label=" {{deal.ReceivingBrokerName}}" styleClass="p-button-link" routerLink="/user/{{deal.ReceivingUserID}}"></p-button>
                                    </div>
                                    <div class="deal-detail">
                                        <b>Proposing Member: </b>
                                        <p-button label=" {{deal.ProposingMemberName}}" styleClass="p-button-link" routerLink="/member/{{deal.ProposingMemberID}}"></p-button>
                                    </div>
                                    <div class="deal-detail">
                                        <b>Receving Member: </b>
                                        <p-button label=" {{deal.ReceivingMemberName}}" styleClass="p-button-link" routerLink="/member/{{deal.ReceivingMemberID}}"></p-button>
                                    </div>
                                    <div class="deal-detail">
                                        <a routerLink="/deal/{{deal.Id}}"><span [class]="'object-badge status-red'">VIEW DEAL</span></a>
                                    </div>
                                </div>
                            </div>
                        </div>                       
                    </ng-template>
                </p-dataView>
            </div>
        </div>
    </div>
</div>
<p-dialog draggable="false" modal="true" header="Search Deals"
          [(visible)]="searchDealsDialogVisible"
          [style]="{width: '75vw'}"
          [baseZIndex]="10000"
          [draggable]="false"
          [resizable]="false"
          [closable]="false"
          [modal]="true">
    <p-divider></p-divider>
    <div class="p-grid">
        <div class="p-col-12 error-notify-text" *ngIf="searchDealsDialogMessage.length>0">
            {{searchDealsDialogMessage}}
        </div>
        <div class="p-col-12">
            <span class="p-float-label">
                <input type="text"
                       pInputText
                       [(ngModel)]="searchDealParms.dealId"
                       name="dealId"
                       (keyup.enter)="searchDeals()" />
                <label for="float-input">Deal Id</label>
            </span>
        </div>
        <div class="p-col-12">
            <span class="p-float-label">
                <input type="text"
                       pInputText
                       [(ngModel)]="searchDealParms.dealAddress"
                       name="propertyAddress"
                       (keyup.enter)="searchDeals()" />
                <label for="float-input">Property Address</label>
            </span>
        </div>
        <div class="p-col-12">
            <span class="p-float-label">
                <input type="text"
                       pInputText
                       [(ngModel)]="searchDealParms.proposingBroker"
                       name="proposingBroker"
                       (keyup.enter)="searchDeals()" />
                <label for="float-input">Proposing Broker</label>
            </span>
        </div>
        <div class="p-col-12">
            <span class="p-float-label">
                <input type="text"
                       pInputText
                       [(ngModel)]="searchDealParms.receivingBroker"
                       name="receivingBroker"
                       (keyup.enter)="searchDeals()" />
                <label for="float-input">Receiving Broker</label>
            </span>
        </div>
        <div class="p-col-12">
            <span class="p-float-label">
                <input type="text"
                       pInputText
                       [(ngModel)]="searchDealParms.clientCompany"
                       name="clientCompany"
                       (keyup.enter)="searchDeals()" />
                <label for="float-input">Client Company</label>
            </span>
        </div>
        <div class="p-col-12">
            <span class="p-float-label">
                <input type="text"
                       pInputText
                       [(ngModel)]="searchDealParms.proposingMember"
                       name="proposingMember"
                       (keyup.enter)="searchDeals()" />
                <label for="float-input">Proposing Member</label>
            </span>
        </div>
        <div class="p-col-12">
            <span class="p-float-label">
                <input type="text"
                       pInputText
                       [(ngModel)]="searchDealParms.receivingMember"
                       name="receivingMember"
                       (keyup.enter)="searchDeals()" />
                <label for="float-input">Receiving Member</label>
            </span>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button (click)="searchDeals()" label="Search" styleClass="p-button-text"></p-button>
        <p-button (click)="cancelSearch()" label="Cancel" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>

